import * as types from './mutation-types'

export const setRegions = makeAction('SET_REGIONS')
export const setTypes = makeAction('SET_TYPES')
export const updateType = makeAction('UPDATE_TYPE')
export const updateRegion = makeAction('UPDATE_REGION')
export const closeRightPanel = makeAction('CLOSE_RIGHT_PANEL')
export const openRightPanel = makeAction('OPEN_RIGHT_PANEL')
export const setCurrentTrip = makeAction('SET_CURRENT_TRIP')
export const closeGallery = makeAction('CLOSE_GALLERY')
export const openGallery = makeAction('OPEN_GALLERY')
export const setCurrentDest = makeAction('SET_CURRENT_DEST')
export const openSubPanel = makeAction('OPEN_SUBMIT_PANEL')
export const closeSubPanel = makeAction('CLOSE_SUBMIT_PANEL')
export const openContact = makeAction('OPEN_CONTACT_PANEL')
export const closeContact = makeAction('CLOSE_CONTACT_PANEL')

function makeAction (type) {
  return ({ commit }, ...args) => commit(type, ...args)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js